<template>
  <div class="nav">
    <div class="main-nav container">
      <div class="left">

        <div class="mobile-logo">
          <img
               class="logo-mobile"
               src="../assets/ccovi-icon.svg"
          />
          <h1>TanninAlert</h1>
        </div>

        <router-link
                     to="/overview"
                     class="menu-item"
        >
          Overview
        </router-link>
        <router-link
                     to="/regional"
                     class="menu-item"
                     v-if="$auth.check()"
        >
          Regional Tannin
        </router-link>
        <router-link
                     to="/samples"
                     class="menu-item"
                     v-if="$auth.check()"
        >
          {{mySamplesText}}
        </router-link>
      </div>
      <div class="right">
        <a href="#"
           class="menu-item-mobile"
           id="open-app-main-nav"
           @click="mobileNavOpen = !mobileNavOpen"
        >
          <span class="fa fa-bars"></span>
        </a>
        <router-link
                     to="/winemaking"
                     class="menu-item"
                     v-if="$auth.check('admin')"
        >
          Winemaking Notes
        </router-link>
        <router-link
                     to="/users"
                     class="menu-item"
                     v-if="$auth.check('admin')"
        >
          Users
        </router-link>
        <router-link
                     to="/login"
                     class="menu-item"
                     v-if="!$auth.check()"
        >
          Login
        </router-link>
        <a
           href="#"
           class="menu-item"
           @click="logout"
           v-if="$auth.check()"
        >
          Logout {{ $auth.user().name }}
        </a>
      </div>
    </div>
    <transition name="fade">
      <div
           class="mobile-nav"
           v-if="mobileNavOpen"
      >
        <div class="icons">
          <router-link
                       to="/overview"
                       class="menu-item"
          >
            Overview
          </router-link>
          <router-link
                       to="/regional"
                       class="menu-item"
                       v-if="$auth.check()"
          >
            Regional Tannin
          </router-link>
          <router-link
                       to="/samples"
                       class="menu-item"
                       v-if="$auth.check()"
          >
            {{mySamplesText}}
          </router-link>
          <router-link
                       to="/winemaking"
                       class="menu-item"
                       v-if="$auth.check('admin')"
          >
            Winemaking Notes
          </router-link>
          <router-link
                       to="/users"
                       class="menu-item"
                       v-if="$auth.check('admin')"
          >
            Users
          </router-link>
          <router-link
                       to="/login"
                       class="menu-item"
                       v-if="!$auth.check()"
          >
            Login
          </router-link>
          <a
             href="#"
             class="menu-item"
             @click="logout"
             v-if="$auth.check()"
          >
            Logout {{ $auth.user().name }}
          </a>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>

export default {
  name: 'AppMainNav',
  data() {
    return {
      mobileNavOpen: false,
    };
  },
  methods: {
    logout() {
      this.$auth.logout();
      // auth.logout('login');
      // this.$forceUpdate();
    },
  },
  computed: {
    mySamplesText() {
      const roles = this.$auth.user().roles;
      let text = '';
      if (roles.includes('winemaker-multi')) {
        text = 'My Samples - Ripening';
      } else {
        text = 'My Sample - Harvest';
      }
      return text;
    },
  },
};
</script>

<style lang="scss" scoped>
  @import '../assets/_colors.scss';
  @import '../assets/_globals.scss';

  .nav{
    background-color: $red;
  }

  .container{
    max-width: $container-width;
    width: 100%;
    margin-left: auto;
    margin-right: auto;
    padding-left: 1rem;
    padding-right: 1rem;
    box-sizing: border-box;
    display: flex;
    flex-direction: row;
    @media screen and (max-width: $break-medium){
      padding: 0;
    }
  }

  .mobile-logo{
    display: none;
    @media screen and (max-width: $break-medium){
      display: flex;
    }
    img{
      height: $bar-height - 10px;
      width: auto;
      padding-left: .75rem;
      padding-right: .75rem;
    }

    h1{
      color: $white;
      margin: 0;
      flex: 1;
      font-size: 1.4rem;
      height: $bar-height;
      line-height: $bar-height;
      font-weight: 400;
    }
  }

  .main-nav{
    margin-top: 1rem;
    height: $bar-height;
    width: 100%;
    display: flex;
    flex-direction: row;
    color: $white;

    @media screen and (max-width: $break-medium){
      margin-top: 0;
    }

    .left{
      flex: 1;
    }
    .menu-item{
      @media screen and (max-width: $break-medium) {
        display: none;
      }
    }
    .menu-item-mobile{
      display: none;
      @media screen and (max-width: $break-medium) {
        display: inline-block;
      }
    }
    a{
      display: inline-block;
      color: inherit;
      text-decoration: none;
      line-height: $bar-height;
      height: $bar-height;
      padding: 0 15px 0 15px;
      transition: background $transition-time;
      &:hover, &.router-link-active{
        background-color: $dark-red;
      }
    }
  }

  .mobile-nav{
    background-color: $dark-red;
    display: none;
    flex-direction: row;
    color: $white;

    @media screen and (max-width: $break-medium){
      display: flex;
    }
    .icons{
      flex: 1;
      display: flex;
      flex-direction: column;
      align-items: center;
      .menu-item{
        color: inherit;
        line-height: $bar-height;
        text-decoration: none;
        padding: 0 15px 0 15px;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/AppMainNav.vue